import { get } from './requests'

export const getSummary = key => get(['new', 'summary'], { key })

export const getUpcomingGoals = key => get(['upcoming-goals'], { key })

export const getPeopleYouMayKnow = key => get(['people-you-may-know'], { key })

export const getAnnouncements = key => get(['announcements'], { key })

export const getUpcomingCall = key => get(['new', 'upcoming-calls'], { key })
